import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectableTypes.includes(_ctx.field.field_type))
      ? (_openBlock(), _createBlock(_component_TextfieldTag, {
          key: 0,
          placeholder: `選択肢`,
          style: {"height":"50px","width":"280px"},
          class: "fl fs14 roundForm",
          value: _ctx.selvalue,
          onInputValue: _ctx.inputSelValue
        }, null, 8, ["value", "onInputValue"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_TextfieldTag, {
            placeholder: `選択肢`,
            style: {"height":"50px","width":"230px"},
            class: "fl fs14 roundForm",
            value: _ctx.selvalue,
            onInputValue: _ctx.inputSelValue
          }, null, 8, ["value", "onInputValue"]),
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/select_images.png`),
            class: "fl mt13 ml10 mr3 pointer",
            width: "22",
            height: "22",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadSelImage && _ctx.uploadSelImage(...args)))
          }, null, 8, _hoisted_3)
        ])),
    _createElementVNode("img", {
      src: _ctx.$getAssetImageUrl(`/assets/icons/updown.png`),
      class: "fl mt13 ml10",
      width: "24",
      height: "22",
      style: {"cursor":"row-resize"}
    }, null, 8, _hoisted_4),
    _createElementVNode("img", {
      src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
      class: "fl mt13 ml10 pointer",
      width: "24",
      height: "24",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteSel && _ctx.deleteSel(...args)))
    }, null, 8, _hoisted_5),
    _hoisted_6
  ]))
}